import { createTheme, ThemeProvider } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { HashRouter } from 'react-router-dom';
import App from './App';

function Main() {
  const theme = createTheme();

  return (
    <ErrorBoundary fallbackRender={({ error }) => (
      <div>
        <h2>Something went wrong, please send a screenshot to contact@feedbackpack.eu !</h2>
        <pre>{error.message}</pre>
      </div>
    )}>
      {/* <ErrorBoundary FallbackComponent={ErrorFallback}> */}
      <ThemeProvider theme={theme}>
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default Main;
